<template>
	<BasicBanner :dismissal-key="dismissalKey" data-context="VCX banner">
		<p class="mr-200 balance-text"
			>{{ bannerText }}
			<BaseLink class="text-color-white text-decoration-underline font-weight-bold" :link="learnMoreLink"
				><span v-html="deorphanText(learnMoreLink.text)"></span></BaseLink
		></p>
	</BasicBanner>
</template>

<script setup lang="ts">
import BasicBanner from '@components/layout/basic-banner.vue';
import { deorphanText } from '@filters/shared-filters';
import { Link } from 'types/layout';

const dismissalKey = 'dismiss-vcx-banner';

const bannerText =
	'The Innovation Fund is now VCX, a public venture capital fund listed on the New York Stock Exchange.';

const learnMoreLink: Link = {
	text: 'Learn more about VCX',
	router: 'vcx-landing'
};
</script>
<style scoped>
.balance-text {
	text-wrap: balance;
	-webkit-text-wrap: balance;
}
</style>
